export default __webpack_public_path__ + "static/media/leo.a5b79948.mp3";